import * as React from 'react';
import { Button } from "primereact/button";
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { MedicineFilterSettings } from "../../models/medicine";
import AlphabeticalFilter from '../../common/components/alphabeticalFilter/alphabeticalFilter';

interface MedicinesFilterProps {
    onSearchClick: any,
    totalRecordsCount: number
}

interface MedicinesFilterState {
    medicineSettings: MedicineFilterSettings,
    selectedType: null,
    selectedGroup: null,
    filterText: string
}

export class MedicineFilter extends React.Component<MedicinesFilterProps, MedicinesFilterState>  {
    constructor(props) {
        super(props);
        this.state = {
            medicineSettings: new MedicineFilterSettings(),
            selectedType: null,
            selectedGroup: null,
            filterText: ''
        };
    }

    handleAlphaIndexChange = (letter: string) => {
        const currentSettings: MedicineFilterSettings = { ...this.state.medicineSettings };
        currentSettings.name = '';
        currentSettings.title = '';
        currentSettings.number = '';
        currentSettings.alphaIndex = letter;
        const fiterText = this.generateFilterText(currentSettings);
        this.setState({
            medicineSettings: { ...currentSettings },
            filterText: fiterText
        });
        this.handleSearchButtonClick(currentSettings);
    }

    handleChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name;

        const currentSettings: MedicineFilterSettings = { ...this.state.medicineSettings };
        currentSettings[name] = value;
        const fiterText = this.generateFilterText(currentSettings);
        this.setState({
            medicineSettings: { ...currentSettings },
            filterText: fiterText
        });
    }

    generateFilterText = (settings) => {
        let result = '';

        if (settings.alphaIndex) {
            result += "Start with <strong>'" + settings.alphaIndex + "'</strong>, "
        }
        if (settings.name) {
            result += "Brand Name <strong>'" + settings.name + "'</strong>, "
        }
        if (settings.title) {
            result += "Title <strong>'" + settings.title + "'</strong>, "
        }
        if (settings.number) {
            result += "Number <strong>'" + settings.number + "'</strong>, "
        }

        return result.substr(0, result.length - 2);
    }

    handleSearchButtonClick = (settings) => {
        this.props.onSearchClick(settings);
    }

    handleClearButtonClick = () => {
        this.setState({
            medicineSettings: new MedicineFilterSettings(),
            filterText: ''
        });
        this.handleSearchButtonClick(new MedicineFilterSettings());
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSearchButtonClick(this.state.medicineSettings)
        }
    }

    render() {
        return (
            <Toolbar style={{ marginBottom: '10px' }}>
                <AlphabeticalFilter
                    handleAlphaIndexChange={this.handleAlphaIndexChange}
                    filters={['en', 'bg']}
                />
                <div>
                    <InputText
                        onKeyPress={(e) => this.handleKeyPress(e)}
                        style={{ marginRight: "10px", marginBottom: "5px" }}
                        name="name"
                        placeholder="Brand Name"
                        onChange={this.handleChange}
                        value={this.state.medicineSettings && this.state.medicineSettings.name ? this.state.medicineSettings.name : ''}
                    />
                    <InputText
                        onKeyPress={(e) => this.handleKeyPress(e)}
                        name="title"
                        placeholder="Title"
                        style={{ marginRight: "10px", marginBottom: "5px" }}
                        onChange={this.handleChange}
                        value={this.state.medicineSettings && this.state.medicineSettings.title ? this.state.medicineSettings.title : ''}
                    />
                    <InputText
                        onKeyPress={(e) => this.handleKeyPress(e)}
                        name="number"
                        style={{ marginRight: "10px", marginBottom: "5px" }}
                        placeholder="Number"
                        onChange={this.handleChange}
                        value={this.state.medicineSettings && this.state.medicineSettings.number ? this.state.medicineSettings.number : ''}
                    />
                </div>
                <div>
                    <div style={{ float: "left", paddingTop: "5px", marginBottom: "5px" }}>
                        Result: <strong>{this.props.totalRecordsCount}</strong>
                        {this.state.filterText ? ', ' : ''}
                        <span dangerouslySetInnerHTML={{ __html: this.state.filterText }}></span>
                    </div>
                    <div style={{ float: "right" }}>
                        <div>
                            <Button
                                className="p-button-raised"
                                icon="pi pi-filter"
                                style={{ marginRight: "10px" }}
                                label="Filter"
                                onClick={() => this.handleSearchButtonClick(this.state.medicineSettings)}
                            />
                            <Button
                                className="p-button-secondary p-button-raised"
                                label="Clear"
                                icon="pi pi-times"
                                onClick={() => this.handleClearButtonClick()}
                            />
                        </div>
                    </div>
                </div>
            </Toolbar>
        )
    }
}

export default MedicineFilter;
